module.exports = __webpack_public_path__ + "img/1-half-sm.65b250ea.jpg";